
import { Injectable } from '@angular/core';
import { HttpApiService } from '../base/http-api.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../entities/api-response.model';
import { ProductCategoryModel } from '../../entities/product-category.model';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoriesService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public get(uid): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpGet('product-categories/view', {uid});
    }

    public set(product: ProductCategoryModel): Observable<ApiResponseModel>
    {
        return this.httpApiService.httpPost('product-categories/store', product);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('product-categories/destroy', { uid });
    }

}
